module.exports = __webpack_public_path__ + "static/media/panco_06.673d8d40.jpg";